var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBottom',_vm._g(_vm._b({attrs:{"text":"","bottomName":_vm.name,"iconName":_vm.icon}},'BaseBottom',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }